import React from 'react';
import PropTypes from 'prop-types';

import DsLabel from '../../atoms/label';
import Btn from '../../atoms/btn';

const BtnBaseContent = ({
  label, className, icon, iconAfter,
}) => (
        <DsLabel icon={icon} iconAfter={iconAfter} className={`text-primary capitalize font-bold ${className}`}>
          {label}
        </DsLabel>
);

// If we have on click we render it as a button, otherwise we use it as label
const BtnBase = (props) => {
  const { onClick, className } = props;
  if (!onClick) {
    return BtnBaseContent(props);
  }
  return (
          <Btn className={`${className || ''}`} onClick={onClick}>
            {BtnBaseContent(props)}
          </Btn>
  );
};

BtnBase.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

BtnBase.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default BtnBase;
